module.exports = __webpack_public_path__ + "img/4.daab15dc.jpg";